import { Button } from '@components/Button';
import DotsLoadingSpinner from '@components/DotsLoadingSpinner/DotsLoadingSpinner';
import { Popover, PopoverPosition } from '@components/Popover/Popover';
import PopoverBody from '@components/Popover/PopoverBody';
import PopoverHeader from '@components/Popover/PopoverHeader';
import GlobusIcon from '@components/Globus';
import { t } from '@lingui/macro';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
import React, { useCallback, useRef, useState } from 'react';
import LocaleButton from './components/LocaleButton';
import styles from './LanguageDropDown.module.scss';
import { useI18n } from 'modules/Common/components/I18n/context';
import defaultLanguage from 'common/constants/defaultLanguage';
export const LanguageDropDown = ({ className }) => {
    const refElement = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const { language = defaultLanguage, locales, updateLanguage, loading: localeIsLoading } = useI18n();
    const { translatedName = '', cultureRegionCode = '', isoCode = '' } = language;
    const [rootClass, getChildClass] = getClassName({
        className,
        styles,
        modifiers: {
            loading: localeIsLoading,
        },
        rootClass: 'languageDropDown',
    });
    const handlePopup = useCallback((open = !isOpen) => {
        setIsOpen(open);
    }, [isOpen, setIsOpen]);
    const handleLanguageChange = useCallback((locale) => {
        updateLanguage(locale);
        handlePopup();
    }, [updateLanguage, handlePopup]);
    return (<div className={rootClass}>
            {/* Changing button to display: hidden when loading because the popover always
            needs a component to attach to, should be useRef but we're stuck with this
            until we move off OUC */}
            {localeIsLoading ? (<DotsLoadingSpinner className={getChildClass('spinner')} data-testid="LanguageDropDown-Spinner"/>) : (<>
                    <Button id="lang" data-testid="LanguageDropDown-Button" aria-label={`${translatedName} (${cultureRegionCode})`} color="transparent" className={getChildClass('languageButton')} onClick={handlePopup} ref={refElement} variant="text">
                        <span className={getChildClass('languageButtonText')}>
                            {translatedName} ({cultureRegionCode})
                            <GlobusIcon className={getChildClass('languageIcon')}/>
                        </span>
                    </Button>
                    <Popover initialPosition={PopoverPosition.BOTTOM_RIGHT} open={isOpen} onClose={() => setIsOpen(false)} refElement={refElement.current} initialWidth={600} noScroll>
                        <PopoverHeader className={getChildClass('popoverHeader')} onClose={() => setIsOpen(false)}>
                            <GlobusIcon className={getChildClass('worldIcon')} color="primary" style={{ color: '#3777bc', height: '1.5rem', width: '1.5rem' }}/>
                            {t `Languages`}
                        </PopoverHeader>
                        <PopoverBody className={getChildClass('popoverBody')}>
                            {locales?.length &&
                locales.map((locale) => (<LocaleButton key={locale.lcId} handleLanguageChange={handleLanguageChange} locale={locale} selected={isoCode === locale?.isoCode}/>))}
                        </PopoverBody>
                    </Popover>
                </>)}
        </div>);
};
